// @flow

import styled from "@emotion/styled";

import { colors, fontSize, spacing } from "./constants";
import {
  UnifizeLogo,
  InfoText,
  TextContainer,
  AuthFormHeader,
  Button,
  OuterWithLogoAndNav,
  InputAndLabelWrapper,
  Container,
  FlexColoumProvider
} from "./auth";
import emailVerifiedImage from "src/img/email-sent.svg";
import teamImage from "src/img/team-png-picture.webp";
import logo from "src/img/unifize-logo-horizontal.svg";

const FlexRowProvider = styled(FlexColoumProvider)`
  flex-flow: row;
`;

const UnifizeLogoColored = styled(UnifizeLogo)`
  background-image: url(${logo});
`;

const OuterWithLogo = styled(OuterWithLogoAndNav)`
  width: auto;
  margin: 0 ${spacing.spacing2};
  min-width: 328px;
  height: auto;
`;

const GreyInfoText = styled(InfoText)`
  color: ${colors.defaultGrey};
  font-weight: normal;
  line-height: 1.67;
`;

const GreyTextContainer = styled(TextContainer)`
  color: ${colors.defaultGrey};
`;

const SetupInputAndLabelWrapper = styled(InputAndLabelWrapper)`
  margin: 6px ${spacing.spacing3};
  @media (max-width: 600px) {
    margin: 6px ${spacing.spacing2};
  }
`;

const SetupInputAndLabelWrapperGrid = styled(InputAndLabelWrapper)`
  grid-area: "inherit";
`;

const OrgSetupForm = styled.form`
  display: flex;
  flex-flow: column;
  width: 100%;
  height: 357px;
  border-radius: 4px;
  box-shadow: 0 0 4px 0 ${colors.loginFormBoxShadowColor};
  background-color: ${colors.pureWhite};
  width: auto;
  height: auto;
  min-width: 328px;
  box-shadow: 0 4px 8px 0 ${colors.setupFormBoxShadowColor};
  border-radius: 4px;
  margin: 0 auto;

  @media (max-width: 600px) {
    max-width: 328px !important;
  }
`;

const SetupFormHeader = styled(AuthFormHeader)`
  padding-left: ${spacing.spacing3};
  margin-bottom: 10px;
  height: auto;
  padding-right: 27px;
  width: auto;
`;

const ButtonContainer = styled(AuthFormHeader)`
  height: 65px;
  justify-content: flex-end;
  padding: ${spacing.spacing0} ${spacing.spacing2};
  margin: ${spacing.spacing0} 0 0 0;
  display: block;
  text-align: right;
  width: auto;
  > button {
    height: 2.1875rem;
    min-width: 5rem;
  }
`;

const PrivacyPolicyTextContainer = styled.div`
  padding: ${spacing.spacing3} ${spacing.spacing2} ${spacing.spacing2}
    ${spacing.spacing3};
  text-align: left;
  font-size: ${fontSize.t3};
  color: ${colors.defaultGrey};
  line-height: 1.67;
`;

const PrimaryButton = styled(Button)`
  margin: ${spacing.spacing0};
  height: 32px;
  border-radius: 3px;
  height: 32px;
  width: auto;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  padding: 9px 16px;
  font-size: ${fontSize.t3};

  &:disabled {
    background-color: ${colors.defaultGrey};
    color: ${colors.pureWhite};
    border: 1px solid ${colors.disabledBorderGrey};
    cursor: not-allowed;
  }
`;

const SecondaryButton = styled(PrimaryButton)`
  background-color: ${colors.pureWhite};
  color: ${colors.black};
  box-shadow: 0 0 0 1px ${colors.grey};
  width: 85px;
`;

const ImageContainer = styled(Container)`
  margin: 0;
  margin-bottom: 16px;
  margin-top: 32px;
`;

const EmailVerificationSentImage = styled.div`
  background-repeat: no-repeat;
  margin: auto;
  width: 166.3px;
  height: 169px;
  object-fit: contain;
  background-image: url(${emailVerifiedImage});
`;

const ParaContainer = styled.div`
  margin: ${spacing.spacing4} 0;
  font-size: ${fontSize.t0};
  width: 521px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: center;
  color: ${colors.pureWhite};

  @media (max-width: 600px) {
    width: 328px !important;
  }
`;

const ParaHeader = styled.h1`
  font-size: 24px;
  color: ${colors.pureWhite};
  line-height: 1.67;
`;

const ParaBody = styled.div`
  font-size: ${fontSize.t0};
  line-height: 1.67;
  font-weight: normal;
`;

const ParaTextBold = styled.b`
  color: ${colors.pureWhite};
`;

const ParaTextBoldBlack = styled.b`
  color: ${colors.setupBlack};
`;

const ParaFooter = styled.div`
  font-size: ${fontSize.t3};
  line-height: 4.67;
  color: ${colors.pureWhite};
`;

const ParaLink = styled.a`
  display: inline-block !important;
  font-size: 12px;
  line-height: 0.8;
  cursor: pointer;
  color: ${colors.pureWhite};
  border-bottom: 1px solid rgba(255, 255, 255, 0.75);
`;

const ParaLinkBlack = styled(ParaLink)`
  color: ${colors.setupBlack};
`;

const ProfileSetupForm = styled(OrgSetupForm)`
  width: 464px;
`;

const TeamSetupForm = styled(OrgSetupForm)`
  width: 393px;
`;

const ProfileSetupGridProvider = styled.div`
  display: grid;
  grid-template-areas:
    "input upload"
    "input upload";
  grid-template-columns: 256px auto;
  grid-gap: 12px;
  padding: 16px 24px;
  padding-top: 6px;

  & > div {
    margin: 0;
  }

  @media (max-width: 600px) {
    grid-template-areas:
      "input upload"
      "input upload";
    padding: 6px 16px 16px 16px;
    grid-gap: 16px;
    grid-template-columns: auto auto;
  }
`;

const ImageUploadInput = styled.div`
  border: 1px dashed #bbbbbb;
  backgroud: transparent;
  padding: 48px 16px;
  width: 128px;
  height: 128px;
  font-weight: normal;
  font-style: normal;
  font-size: ${fontSize.t3};
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: normal;
  color: #888888;
  margin: auto 0 auto 26px !important;
  border-radius: 2px;
  grid-area: upload;
  text-align: center;
  cursor: pointer;

  @media (max-width: 600px) {
    width: 114px;
    height: 114px;
    margin: 0 !important;
    padding: 38px 8px;
    margin-left: auto !important;
    margin-top: auto !important;
  }
`;

const ImagePreview = styled(ImageUploadInput)`
  object-fit: contain;
  padding: 0;
  position: relative;
  cursor: default;

  > img {
    max-width: 100%;
    height: inherit;
    width: inherit;
  }

  > button {
    position: absolute;
    width: 20px;
    height: 20px;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    background-color: ${colors.dullWhite};
    color: black;
    padding: initial;
    font-size: 10px;
    border: none;
    cursor: pointer;
    border-radius: 50%;
    border: 1px solid black;
    text-align: center;
    font-weight: bold;
    opacity: 0.5;

    &:hover {
      opacity: 1;
    }
  }
`;

const SubHeader = styled.div`
  margin: 18px auto 6px 24px;
  width: auto;
  font-family: Lato;
  font-size: ${fontSize.t2};
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: ${colors.mediumBlack};

  @media (max-width: 600px) {
    margin-left: 16px;
  }
`;

const FooterContainer = styled(ParaContainer)`
  margin: 18px auto 18px ${spacing.spacing3};
  color: ${colors.setupBlack};
  width: auto;
  font-weight: normal;
  text-align: left;
  font-size: 12px;

  @media (max-width: 600px) {
    margin-left: 16px;
  }
`;

const TeamImageWrapper = styled.div`
  flex-grow: 1;
  margin-left: 128px;
  align-self: flex-end;
  margin-bottom: 45px;

  @media (max-width: 1083px) {
    display: none;
  }
`;

const TeamImage = styled.div`
  background-image: url(${teamImage});
  object-fit: contain;
  width: 533px;
  height: 318px;
`;

export {
  GreyInfoText,
  EmailVerificationSentImage,
  ImagePreview,
  TeamImageWrapper,
  SubHeader,
  ParaBody,
  ParaLink,
  ParaHeader,
  ParaFooter,
  UnifizeLogoColored,
  GreyTextContainer,
  OrgSetupForm,
  ButtonContainer,
  ParaTextBold,
  PrivacyPolicyTextContainer,
  TeamSetupForm,
  PrimaryButton,
  OuterWithLogo,
  ParaContainer,
  FooterContainer,
  SetupInputAndLabelWrapper,
  SetupInputAndLabelWrapperGrid,
  ProfileSetupGridProvider,
  ProfileSetupForm,
  SetupFormHeader,
  SecondaryButton,
  FlexRowProvider,
  ImageUploadInput,
  ImageContainer,
  TeamImage,
  ParaLinkBlack,
  ParaTextBoldBlack
};
